module.exports = __webpack_public_path__ + "media/cyc_compromiso.477b14e4.mp4";